<template lang="pug">
div
  q-form
    .row(v-for="(row, i) in data.scheme", :ref="row[0]['name']")
      div(v-for="field in row", :key="field.name", :class="'col-' + field.col", style="padding: 5px")
        component(
          v-show="getFieldDataByName(field)",
          :is="getFieldComponent(getFieldDataByName(field))",
          @show-field="showField",
          @fields-loaded="fieldsLoaded",
          :parentData="{ allFields: data.fields, method, method_limit: getFieldDataByName(field).method_limit, grid, data: [getFieldDataByName(field)], item_id, building_id, formLoaded }"
        )

    slot(name="after")

    .row.justify-center.new-edit-form-submit-wrapper
      q-btn.new-edit-form-submit(flat, no-caps, :label="new_edit_form_locales.submit", @click="submitForm")
</template>

<script>
import fields from "../../fields";
import { removeHiddenFormField } from "@/services/useFormSchemaFields";

export default {
  components: {
    fields,
  },

  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      // data: this.parentData.data,
      method: this.parentData.method,
      grid: this.parentData.grid,
      // Значение пустых строк по умолчанию сделано чтобы не передавать от родителя item_id и building_id.
      // В компоненте Form они передаются как (значение от родителя || "")
      item_id: this.parentData.item_id || "",
      building_id: this.parentData.building_id || "",
    };
  },

  computed: {
    data() {
      return this.parentData.data;
    },
    formLoaded() {
      return this.parentData.formLoaded;
    },
  },

  methods: {
    showField(data) {
      if (!data.val) {
        removeHiddenFormField({ store: this.$store, gridName: this.grid, formData: this.data, fieldName: data.name });
      }

      this.$nextTick(() => {
        if (this.$refs[data.name]) {
          if (data.val) {
            this.$refs[data.name][0].style.display = "flex";
          } else {
            this.$refs[data.name][0].style.display = "none";
          }
        }
      });
    },

    fieldsLoaded(field) {
      this.$emit("fields-loaded", field);
    },

    submitForm() {
      this.$emit("submit-form");
    },

    getFieldComponent(key) {
      if (key) {
        return fields[key.type];
      }
    },

    getFieldDataByName(field) {
      return this.data.fields.find(f => f.name === field.name);
    },
  },
};
</script>

<style lang="scss">
.new-edit-form-submit-wrapper {
  position: sticky;
  bottom: 0;
  padding: 40px 0;
  width: 100%;
}
</style>
